// create react functional component and export it calling it SearchFilter
import React, { FC } from 'react';
import OpDrawer from 'components/Common/op-ui-wrappers/OpDrawer/OpDrawer';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import OpButton from 'components/Common/op-ui-wrappers/OpButton/OpButton';
import SearchFilters from 'components/SearchPage/SearchFilters/SearchFilters';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import getNumberOfFiltersApplied from 'store/search/selector/getNumberOfFiltersApplied';
import { clearSearchFiltersAction, setSearchPageNrAction } from 'store/search/slice';
import updateSearchQueryStringOperation from 'store/search/operation/updateSearchQueryStringOperation';
import { useHistory } from 'react-router';
import styles from './SearchFilter.module.scss';

interface OwnProps {
  visible: boolean;
  onClose: any;
  onShow: () => void;
}

const SearchFilter: FC<OwnProps> = ({ visible, onClose, onShow }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const totalFiltersApplied = useSelector(getNumberOfFiltersApplied);

  const showCancel = totalFiltersApplied === 0;

  const clearFilters = () => {
    dispatch(clearSearchFiltersAction());
    dispatch(setSearchPageNrAction(1));
    dispatch(updateSearchQueryStringOperation(history));
    onClose();
  };

  return (
    <OpDrawer visible={visible} onClose={onClose} className={styles.filterDrawer}>
      <div slot="label" className={styles.drawerLabel}>
        <OpText variant="title-medium-bold" className={styles.upperCase}>
          {t('txt_filters')}
        </OpText>
      </div>
      <div slot="content" className={styles.content}>
        <SearchFilters showTitle={false} />
      </div>
      <div slot="actions" className={styles.drawerActions}>
        <OpButton variant="primary" block onClick={onShow}>
          {t('txt_apply_filters')}
        </OpButton>
        {showCancel && (
          <OpButton variant="secondary" block onClick={onClose}>
            {t('txt_cancel')}
          </OpButton>
        )}
        {!showCancel && (
          <OpButton variant="secondary" block onClick={clearFilters}>
            <span className={styles.upperCase}>{t('txt_clear_filters')}</span>
          </OpButton>
        )}
      </div>
    </OpDrawer>
  );
};

export default SearchFilter;
